import {
  ShoppingCart, Users, Package, FileSignature, TrendingUp, Building2, UtensilsCrossed,
  Wrench, ClipboardList, Cloud, Sun, Cpu, Calculator,
} from 'lucide-react';

const MODULES = [
  { icon: ShoppingCart, title: 'POS Satış', text: 'Barkodla hızlı satış, nakit/kart ayrımı, fiş ve satış raporları.' },
  { icon: Users, title: 'Müşteri & Veresiye', text: 'Müşteri bazlı borç takibi, tahsilat ve PDF hesap ekstresi.' },
  { icon: Package, title: 'Ürün & Stok', text: 'Ürün kartları, stok giriş/çıkış, düşük stok uyarıları.' },
  { icon: FileSignature, title: 'Teklif Formu', text: 'Logolu, KDV hesaplı profesyonel teklifler ve PDF çıktı.' },
  { icon: TrendingUp, title: 'Gelir / Gider', text: 'Tüm nakit akışınız, kâr-zarar ve dönemsel raporlar.' },
  { icon: Building2, title: 'Apartman Yönetimi', text: 'Aidat, daire, gider ve evrak takibi tek ekranda.' },
  { icon: UtensilsCrossed, title: 'Yemek Sipariş & Mutfak', text: 'Masa/paket sipariş, mutfak ekranı ve menü yönetimi.' },
  { icon: Wrench, title: 'Teknik Servis', text: 'Cihaz kabul, onarım durumu, servis fişi ve resimler.' },
  { icon: ClipboardList, title: 'İş Takibi', text: 'Ekibinizin işlerini planlayın, durumlarını izleyin.' },
  { icon: Cloud, title: 'Bulut Depolama', text: 'Dosyalarınızı saklayın, linkle güvenle paylaşın.' },
  { icon: Sun, title: 'Solar System', text: 'Güneş enerjisi üretimini canlı izleyin, grafiklerle analiz edin.' },
  { icon: Cpu, title: 'Akıllı Takip', text: 'Arduino/ESP cihazlar, sensörler, röleler ve IP kameralar.' },
  { icon: Calculator, title: 'Hesaplama Araçları', text: 'KDV, kâr marjı, iskonto, taksit ve yüzde hesapları.' },
];

export const ModulesGrid = () => (
  <section id="moduller" className="max-w-6xl mx-auto px-5 sm:px-8 py-16" data-testid="landing-modules-section">
    <p className="text-emerald-400 text-xs font-bold uppercase tracking-[0.2em] mb-2">Modüller</p>
    <h2 className="text-2xl sm:text-3xl font-bold text-white mb-8 max-w-xl">İhtiyacınız olan her şey, tek hesapta</h2>
    <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
      {MODULES.map((m, i) => (
        <div key={m.title} className="group p-5 rounded-2xl bg-white/[0.03] border border-white/10 hover:border-emerald-400/50 hover:-translate-y-1 transition-[transform,border-color] duration-300"
          style={{ animation: `fadeInUp .5s ease ${i * 40}ms both` }} data-testid={`landing-module-${i}`}>
          <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-emerald-400 to-emerald-600 flex items-center justify-center mb-4 shadow-lg shadow-emerald-500/20">
            <m.icon className="h-5 w-5 text-white" />
          </div>
          <h3 className="text-white font-semibold mb-1">{m.title}</h3>
          <p className="text-slate-400 text-sm leading-relaxed">{m.text}</p>
        </div>
      ))}
    </div>
  </section>
);
